/**
 * @fileoverview POST handler for the "/engagement/landing_pages/:app_group_id/:landing_page_bson_id/copy/:target_app_group_id" endpoint
 */
import fetch from "@lib/fetch";

import { createMutationFetcherFunctionWithShadowError } from "../reactQueryFetcherAdapters/createMutationFetcherFunctionWithShadowError";
import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { postEngagementLandingPagesAppGroupIdLandingPageIdCopyTargetAppGroupIdCacheKeys } from "./constants";
import type {
  PostEngagementLandingPagesAppGroupIdLandingPageIdCopyTargetAppGroupIdProps,
  EngagementLandingPagesAppGroupIdLandingPageIdCopyTargetAppGroupIdResult,
  EngagementLandingPagesAppGroupIdLandingPageIdCopyTargetAppGroupIdResultErrors,
} from "./types";

export const postEngagementLandingPagesAppGroupIdLandingPageIdCopyTargetAppGroupId = reactQueryMutationAdapter(
  postEngagementLandingPagesAppGroupIdLandingPageIdCopyTargetAppGroupIdCacheKeys,
  createMutationFetcherFunctionWithShadowError<EngagementLandingPagesAppGroupIdLandingPageIdCopyTargetAppGroupIdResultErrors>()(
    ({
      app_group_id: appGroupId,
      landing_page_bson_id: landingPageBsonId,
      target_app_group_id: targetAppGroupId,
    }: PostEngagementLandingPagesAppGroupIdLandingPageIdCopyTargetAppGroupIdProps): Promise<EngagementLandingPagesAppGroupIdLandingPageIdCopyTargetAppGroupIdResult> => {
      return fetch(
        `/engagement/landing_pages/${appGroupId}/${landingPageBsonId}/copy/${targetAppGroupId}`,
        "POST",
        {},
        undefined,
        {
          propagateFetchRequestError: false,
        }
      );
    }
  )
);
